const currentYear = new Date().getFullYear();

module.exports = {
  footerText: `Copyright Phillips Outsourcing © ${currentYear}`,
}
